namespace $ { export class $mol_stringer extends $mol_viewer {

	/// tagName \input
	tagName() {
		return "input"
	}

	/// enabled true
	enabled() {
		return true
	}

	/// hint \
	hint() {
		return ""
	}

	/// type \text
	type() {
		return "text"
	}

	/// attr * 
	/// 	placeholder < hint 
	/// 	type < type
	attr() {
		return $mol_merge_dict( super.attr() , {
			"placeholder" : ()=> <any> this.hint() ,
			"type" : ()=> <any> this.type() ,
		} )
	}

	/// disabled false
	disabled() {
		return false
	}

	/// value \
	@ $mol_mem()
	value( next? : any , prev? : any ) {
		return ( next !== void 0 ) ? next : ""
	}

	/// valueChanged > value
	valueChanged( next? : any , prev? : any ) {
		return this.value( next , prev )
	}

	/// field * 
	/// 	disabled < disabled 
	/// 	value < valueChanged
	field() {
		return $mol_merge_dict( super.field() , {
			"disabled" : ()=> <any> this.disabled() ,
			"value" : ()=> <any> this.valueChanged() ,
		} )
	}

	/// eventChange null
	@ $mol_mem()
	eventChange( next? : any , prev? : any ) {
		return ( next !== void 0 ) ? next : <any> null
	}

	/// event * input > eventChange
	event() {
		return $mol_merge_dict( super.event() , {
			"input" : ( next? : any , prev? : any )=> <any> this.eventChange( next , prev ) ,
		} )
	}

} }

